import { createSlice } from "@reduxjs/toolkit";

export const serviceSlice = createSlice({
  name: "service",
  initialState: {
    fetching: true,
    loadingEnvs: true,
    vendorProfile: {},
    vendorStatus: [],
    notes: [],
    workflowSteps: {},
    roles: {},
    UI_ENV: { AUTOCOMPLETE_API_KEY: "", AGGRID_LICENSE_KEY: "" },
  },
  reducers: {
    updateServiceData: (state, { payload }) => ({ ...state, ...payload }),
    updateVendorProfileDetails: (state, { payload }) => {
      return {
        ...state,
        vendorProfile: {
          ...state.vendorProfile,
          vendorDetail: {
            ...state.vendorProfile.vendorDetail,
            ...payload,
          },
        },
      };
    },
    updateMerchantDetails: (state, { payload }) => {
      return {
        ...state,
        merchantContact: {
          ...state.merchantContact,
          ...payload,
        },
      };
    },
    resetServiceData: (state, action) => ({
      ...state,
      vendorProfile: {},
      vendorStatus: [],
      notes: [],
      merchantContact: {},
      multipleMerchantContactList: [],
    }),
  },
});

export const {
  updateServiceData,
  updateVendorProfileDetails,
  updateMerchantDetails,
  resetServiceData,
} = serviceSlice.actions;
export default serviceSlice.reducer;
